import axios from 'axios'
import { getIdToken } from '~/shared/lib/auth'

interface AccessToken {
  access_token: string
  issued_token_type: string
  token_type: string
  expires_in: number
}

export const getAccessToken = async (tenant: string | undefined) => {
  const idToken = getIdToken()
  const tokenExchangeUrl = import.meta.env.VITE_ZUS_API_URL
  return axios.post<AccessToken>(`${tokenExchangeUrl}/auth/token`, {
    grant_type: 'urn:ietf:params:oauth:grant-type:token-exchange',
    audience: tokenExchangeUrl,
    requested_token_type: 'urn:ietf:params:oauth:token-type:access_token',
    subject_token_type: 'urn:ietf:params:oauth:token-type:id_token',
    subject_token: idToken,
    custom_unique_identifier: tenant,
  })
}
